/**
 * Whether the «برداشت» button may be pressed, and why not. Shared by the wallet page and the home
 * money strip so both behave the same: closed while payouts are off (shadow mode) or nothing is withdrawable.
 */
export function withdrawGate(payoutsEnabled: boolean, withdrawableRial: string | bigint): { disabled: boolean; reason: string | null } {
    if (!payoutsEnabled) return { disabled: true, reason: "دکمهٔ برداشت با باز شدن تسویه فعال می‌شود." };
    if (BigInt(withdrawableRial) <= 0n) return { disabled: true, reason: "فعلاً موجودی قابل برداشت ندارید؛ پورسانت‌ها پس از دورهٔ ضمانت خودکار به اینجا می‌آیند." };
    return { disabled: false, reason: null };
}
